import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import bCategoryService from "./bcategoryService";

export const getCategories = createAsyncThunk(
  "category/getAllCat",
  async (thunkAPI) => {
    try {
      return await bCategoryService.getNewsCategories();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const createNewNewsCat = createAsyncThunk(
  "category/addCategory",
  async (catData, thunkAPI) => {
    try {
      return await bCategoryService.createNewsCategory(catData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getANewsCat = createAsyncThunk(
  "category/getCat",
  async (id, thunkAPI) => {
    try {
      return await bCategoryService.getNewsCategory(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateANewsCat = createAsyncThunk(
  "category/editCategory",
  async (NewsCat, thunkAPI) => {
    try {
      return await bCategoryService.updateNewsCategory(NewsCat);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteANewsCat = createAsyncThunk(
  "category/deleteCategory",
  async (id, thunkAPI) => {
    try {
      return await bCategoryService.deleteNewsCategory(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");
const initialState = {
  bCategories: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const pCategorySlice = createSlice({
  name: "bCategories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCategories.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.bCategories = action.payload.data;
      })
      .addCase(getCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createNewNewsCat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createNewNewsCat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createNewsCategory = action.payload;
      })
      .addCase(createNewNewsCat.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getANewsCat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getANewsCat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.categoryname = action.payload.data.category_name;
      })
      .addCase(getANewsCat.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateANewsCat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateANewsCat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedNewsCategory = action.payload;
      })
      .addCase(updateANewsCat.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteANewsCat.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteANewsCat.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedNewsCategory = action.payload;
      })
      .addCase(deleteANewsCat.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default pCategorySlice.reducer;
